export const ADMIN_ANALYTICS_DATA_FIELDS = {
    ADVERTISER: 'display_name',
    DOWNSTREAM_NETWORK: 'network_id',
    RPC: 'rpc',
    PROFIT: 'profit',
    CM: 'cm',
    GP_PER: 'gp_per',
    TOTAL_INVENTORY: 'total_inventory',
    TOTAL_OPPORTUNITIES: 'total_opportunities',
    TOTAL_SEARCHES: 'total_searches',
    TOTAL_SELECTED: 'total_selected',
    TOTAL_ACCEPTED: 'total_accepted',
    TOTAL_COST: 'total_cost',
    AVG_BID: 'avg_bid',
    AVG_UPSTREAM_BID: 'avg_upstream_bid',
    UPSTREAM_BID: 'upstream_bid',
    SYNDI_CLICK_PROFIT: 'syndi_click_profit',
    SYNDI_CLICK_CM: 'syndi_click_cm',
    COST_PER: 'cost_per',
    TARGET_RATE: 'target_rate',
    BID_RATE: 'bid_rate',
    EPW: 'epw',
    WIN_RATE: 'win_rate',
    SUCCESS_RATE: 'success_rate',
    LEADS_GENERATED: 'leads_generated_count',
    CALLS_GENERATED: 'calls_generated_count',
    CONVERSIONS: 'conv_stats',
    CVR: 'conv_cvr',
    CPA: 'conv_cpa',
    CONV_REVENUE: 'conv_revenue',
    QF_CONVERSION: 'qf_conversion'
}
